import pluralize from 'pluralize'

export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, '$pluralize', { value: pluralize })
  },
}
